import { apiRequest } from '../client';
import type { PageResponse } from '../types';

export interface DynamicRecordView {
  id: string;
  entityDefinitionId: string;
  currentVersion: number;
  data: Record<string, unknown>;
  updatedAt: string;
}

export const dynamicRecordsApi = {
  list: (entityDefinitionId: string, page = 0, size = 20) =>
    apiRequest<PageResponse<DynamicRecordView>>(
      `/api/dynamic-entities/${entityDefinitionId}/records?page=${page}&size=${size}`
    ),

  get: (entityDefinitionId: string, recordId: string) =>
    apiRequest<DynamicRecordView>(
      `/api/dynamic-entities/${entityDefinitionId}/records/${recordId}`
    ),

  create: (
    entityDefinitionId: string,
    data: Record<string, unknown>,
    idempotencyKey?: string
  ) =>
    apiRequest<DynamicRecordView>(
      `/api/dynamic-entities/${entityDefinitionId}/records`,
      {
        method: 'POST',
        body: { data },
        idempotencyKey
      }
    ),

  update: (entityDefinitionId: string, recordId: string, data: Record<string, unknown>) =>
    apiRequest<DynamicRecordView>(
      `/api/dynamic-entities/${entityDefinitionId}/records/${recordId}`,
      {
        method: 'PUT',
        body: { data }
      }
    )
};
